import React from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import defaultFases from "../../constants/DefaultFases";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import ForwardIcon from "@material-ui/icons/Forward";
import "./Fase.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import colors_divisions from "../../constants/colors_divisions";

const useStyles = makeStyles({
  colorPrimary: (props) => ({
    backgroundColor: props.progressBackgroundColor,
  }),
  bar: (props) => ({
    backgroundColor: props.progressColor,
  }),
});

const asPlainText = (value, fallback = "") => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return fallback;
};

const Fase = (props) => {
  let progressBackgroundColor = "";
  let progressColor = "";
  if (props.divisions && props.divisions.length > 1) {
    props.divisions
      .sort((a, b) => {
        if (a.num > b.num) {
          return 1;
        } else if (a.num < b.num) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        } else if (a.id < b.id) {
          return -1;
        } else {
          return 0;
        }
      })
      .forEach((division, i) => {
        if (props.division && division && division.id === props.division.id) {
          progressBackgroundColor = colors_divisions[i % 25].background;
          progressColor = colors_divisions[i % 25].color;
        }
      });
  }
  const theme = useTheme();
  const classes = useStyles({ progressBackgroundColor, progressColor });
  const division = props.division || {};
  const fase = props.fase || {};
  const fases =
    division.fases && typeof division.fases === "object"
      ? division.fases
      : defaultFases;
  const currentFaseMeta = (fases && fases[props.faseKey]) || {};
  const nextFaseName =
    asPlainText(props.nextFase && props.nextFase.name).trim() ||
    asPlainText(
      languages.results && languages.results.theNextPhase,
      "the next phase"
    );
  const participantWord = asPlainText(
    props.tournament && props.tournament.individualPlayers
      ? languages.teams && languages.teams.players
      : languages.tournament && languages.tournament.teams
  );
  const isNextFaseStarted = Boolean(props.nextFase && props.nextFase.started);
  const isCurrentPhase =
    Boolean(currentFaseMeta.started) && !isNextFaseStarted;
  const formatPhaseText = (template, fallback) => {
    const name = asPlainText(nextFaseName);
    const participants = asPlainText(participantWord);
    if (typeof template === "string") {
      return template.replace(/\{0\}/g, name).replace(/\{1\}/g, participants);
    }
    const prefix = asPlainText(fallback);
    return prefix + (name ? " " + name : "");
  };
  const faseKeys =
    fases && typeof fases === "object" ? Object.keys(fases) : [];
  const isFirstStartButton =
    !isNextFaseStarted && String(faseKeys[0]) === String(props.faseKey);
  const previousPhaseIncomplete =
    !isNextFaseStarted && fase.played !== fase.total;
  const phaseButtonTooltip = isNextFaseStarted
    ? formatPhaseText(
        languages.results && languages.results.undoPhaseTooltip,
        languages.results && languages.results.reverseFaseDescription
      )
    : (
        <span>
          {formatPhaseText(
            languages.results && languages.results.startPhaseTooltip,
            languages.results && languages.results.start
          )}
          {isFirstStartButton &&
            languages.results &&
            languages.results.startPhaseTooltipFirst && (
              <span>
                <br />
                <br />
                {asPlainText(
                  languages.results && languages.results.startPhaseTooltipFirst
                )}
              </span>
            )}
        </span>
      );
  const isPhaseButtonDisabled = Boolean(
    props.nextFase &&
      (currentFaseMeta.started === false ||
        (props.tournamentAdmin !== undefined &&
          props.tournamentAdmin.managePhases === false) ||
        (props.nextNextFase && props.nextNextFase.started))
  );
  return (
    <div
      style={{
        textAlign: "center",
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div>
        <div
          className="fase-tile"
          onClick={() => {
            if (props.selectPhase) {
              props.selectPhase(props.faseKey, division.id);
            }
          }}
        >
          <Typography
            variant="body2"
            style={{
              color: currentFaseMeta.started ? "black" : "gray",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {isCurrentPhase && (
              <span
                className="fase-tile-dot"
                style={{ backgroundColor: theme.palette.primary.main }}
              />
            )}
            {asPlainText(currentFaseMeta.name)}
          </Typography>
          {
            <div>
              <Typography
                variant="h6"
                style={{
                  color: currentFaseMeta.started ? "black" : "gray",
                }}
              >
                {(fase.played || 0) + "/" + (fase.total || 0)}
              </Typography>
              <LinearProgress
                color="primary"
                variant="determinate"
                value={
                  ((Number(fase.played) || 0) * 100) /
                  (Number(fase.total) || 1)
                }
                style={{ borderRadius: 5 }}
                classes={classes}
              />
            </div>
          }
        </div>
      </div>
      {props.nextFase && (
        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
          {/* <div>
          <ForwardIcon
            style={{
              color: (props.division.fases || defaultFases)[props.faseKey]
                .started
                ? "black"
                : "gray"
            }}
          />
        </div> */}
          {props.nextFase ? (
            <Tooltip title={phaseButtonTooltip} placement="top">
              <span>
                <Button
                  variant="outlined"
                  onClick={
                    isNextFaseStarted
                      ? props.toggleDialogBack
                      : props.toggleDialog
                  }
                  size="small"
                  color="primary"
                  disabled={isPhaseButtonDisabled}
                  style={
                    previousPhaseIncomplete && !isPhaseButtonDisabled
                      ? {
                          color: "rgba(0, 0, 0, 0.38)",
                          borderColor: "rgba(0, 0, 0, 0.26)",
                        }
                      : undefined
                  }
                >
                  {isNextFaseStarted && <ForwardIcon className="flipped" />}
                  {isNextFaseStarted
                    ? asPlainText(
                        languages.results && languages.results.back,
                        "Undo"
                      )
                    : asPlainText(
                        languages.results && languages.results.start,
                        "Start"
                      )}
                  {!isNextFaseStarted && <ForwardIcon />}
                </Button>
              </span>
            </Tooltip>
          ) : (
            <div style={{ height: 32 }} />
          )}
        </div>
      )}
    </div>
  );
};

export default Fase;
